import { useIntl } from 'react-intl';
import { LinearProgress, Stack } from '@rossum/ui/material';
import { getColor } from '../helpers';
import { LabeledValueInRow } from './LabeledValueInRow';

type Period = {
  beginDate: string;
  endDate: string;
};

type BillingPeriodProgressProps = {
  currentPeriod: Period;
  usedPercentage: number;
};

const BillingPeriodProgress = ({
  currentPeriod,
  usedPercentage,
}: BillingPeriodProgressProps) => {
  const intl = useIntl();
  const { beginDate, endDate } = currentPeriod;

  const usedColor = getColor(usedPercentage);

  return (
    <Stack direction="column" spacing={1}>
      <LinearProgress
        variant="determinate"
        color={usedColor}
        value={Math.min(usedPercentage, 100)}
        sx={{ height: theme => theme.spacing(3) }}
      />
      <Stack direction="row" width="100%" justifyContent="space-between">
        <LabeledValueInRow
          label="containers.billing.overview.started"
          labelColor="text.disabled"
          value={intl.formatDate(new Date(beginDate), { dateStyle: 'medium' })}
        />
        <LabeledValueInRow
          label="containers.billing.overview.ends"
          labelColor="text.disabled"
          value={intl.formatDate(new Date(endDate), { dateStyle: 'medium' })}
        />
      </Stack>
    </Stack>
  );
};

export { BillingPeriodProgress };
